import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { hashCodeOfWithFallback } from '../../../../util/hash-code';

import statuses from '../../../../constants/statuses';
import { subscriptionPropType } from '../../../../types/subscription';
import { actionPropType } from '../../../../types';

import DeviationNotifications from '../../../DeviationNotifications';
import { isActive } from '../../utils/helpers';
import SubscriptionDetailHeader from '../SubscriptionDetailHeader';
import DeliveryDetails from './DeliveryDetails';
import Details from './Details';
import CreditBalance from './CreditBalance';
import InfoSection from './InfoSection';

const SubscriptionDetails = ({ subscription = {}, action, theme }) => {
    const { status, product, payment, delivery, id: subscriptionId } = subscription;
    const creditBalance = payment?.creditBalance;
    const displayCreditBalanceAboveInfo = !!creditBalance
        && [statuses.EXPIRED_TERMED, statuses.EXPIRED_EVERGREEN, statuses.EMPTY].includes(status);
    const classname = classnames({
        [theme.detailsContainer]: true,
        [theme.empty]: status === statuses.EMPTY,
    });

    return (
        <div className={ classname }>
            { subscriptionId && delivery && isActive(subscription)
                && <DeviationNotifications subscriptionId={ subscriptionId } />}
            <SubscriptionDetailHeader
                theme={ theme }
                name={ product.name }
                description={ product.description }
            />
            { displayCreditBalanceAboveInfo && (
                <CreditBalance
                    key={ hashCodeOfWithFallback() }
                    payment={ payment }
                    withDivider
                    theme={ theme }
                />
            )}
            <InfoSection
                status={ status }
                product={ product }
                action={ action }
                payment={ payment }
                theme={ theme }
                subscriptionId={ subscriptionId }
            />
            { !displayCreditBalanceAboveInfo && (
                <CreditBalance
                    key={ hashCodeOfWithFallback() }
                    payment={ payment }
                    theme={ theme }
                />
            ) }
            <Details
                status={ status }
                product={ product }
                payment={ payment }
                theme={ theme }
            />
            {status !== statuses.SHARED && !!delivery && (
                <DeliveryDetails
                    subscriptionId={ subscriptionId }
                    delivery={ delivery }
                    theme={ theme }
                />
            )}
        </div>
    );
};

SubscriptionDetails.propTypes = {
    subscription: subscriptionPropType.isRequired,
    action: actionPropType,
    theme: PropTypes.shape({}),
};

export default SubscriptionDetails;
